<br>




        <div class="d-flex justify-content-center" style="margin-top: 50px;">
            <h4>Costes de producto</h4>
        </div>
   
        <div class="d-flex justify-content-center">
            <table class="table-style">
                <tr>
                    <th style="width: 25%;">Producto</th>
                    <th style="width: 25%;">Cantidad</th>
                    <th style="width: 25%;">Precio</th>
                    <th style="width: 25%;">Total</th>
                </tr>
                <tr  >
                    <td>{{ model.producto }}</td>
                    <td style="text-align: right;">{{cuantityFormat(model.cantidad ?? 0)}} {{model.producto_unidades}}</td>
                    <td style="text-align: right;">{{moneyFormat(model.producto_precio ?? 0)}} €</td> 
                    <td style="text-align: right;">{{moneyFormat((model.producto_precio || 0) * (model.cantidad || 0))}} €</td> 
                </tr>
            </table>
        </div>
      
        <div class="d-flex justify-content-center" style="margin-top: 50px;">
            <h4>Costes de maquinaria</h4>
        </div>
   
        <div class="d-flex justify-content-center">
            <table class="table-style">
                <tr>
                    <th style="width: 25%;">Maquinaria</th>
                    <th style="width: 25%;">Horas</th>
                    <th style="width: 25%;">Precio</th>
                    <th style="width: 25%;">Total</th>
                </tr>
                <tr>
                    <td>{{ model.maquinaria }}</td>
                    <td style="text-align: right;">{{ model.tiempo_total || model.horas }}</td>
                    <td style="text-align: right;">{{moneyFormat(model.precio_hora_maquinaria ?? 0)}} €</td> 
                    <td style="text-align: right;">{{ moneyFormat(transformStringToNumber(model.maquinaria_resultado ?? '') || model.maquinaria_precio_total || model.precio_total || 0) }} €</td> 
                </tr>
            </table>
        </div>

        <div class="d-flex justify-content-center" style="margin-top: 50px;">
            <h4>Costes de trabajadores</h4>
        </div>
   
        <div class="d-flex justify-content-center">
            <table class="table-style">
                <tr>
                    <th style="width: 25%;">Trabajador</th>
                    <th style="width: 25%;">Horas</th>
                    <th style="width: 25%;">Precio</th>
                    <th style="width: 25%;">Total</th>
                </tr>
                <tr *ngFor="let item of model.lista_trabajadores; let i = index">
                    <td>{{ item.nombre }} {{ item.apellidos }}</td>
                    <td style="text-align: right;">{{ model.tiempo_total || model.horas }}</td>
                    <td style="text-align: right;">{{ moneyFormat(item.aux_cargos ?? 0) }} €</td>
                    <td style="text-align: right;">{{ moneyFormat(transformStringToNumber(item.aux_precio_total ?? '')) }} €</td>
                </tr>
                <tr *ngIf="!model.lista_trabajadores?.length && model.trabajadores_nombres">
                    <td>{{ model.trabajadores_nombres }}</td>
                    <td style="text-align: right;">{{ model.tiempo_total || model.horas }}</td>
                    <td style="text-align: right;">{{ moneyFormat(model.precio_cargo ?? 0) }} €</td>
                    <td style="text-align: right;">{{ moneyFormat(transformStringToNumber(model.coste ?? '')) }} €</td>
                </tr>
                <tr>
                    <td style="border: none;"></td>
                    <td style="border: none;"></td>
                    <td style="border: none;"></td>
                    <td style="text-align: right;">{{ moneyFormat(sumaAuxTrabajadores(model.tiempo_total || model.horas || '') || transformStringToNumber(model.coste ?? '')) }} €</td>
                </tr>
            </table>
        </div><!-- precio_total -->
        <div class="d-flex justify-content-center" style="margin-top: 10px;">
            <table class="table-style">
                <tr>
                    <th style="border: none"></th>
                    <th style="border: none"></th>
                    <th style="border: none; "></th>
                    <th style="border: none; width: 25% ">Total</th>
                    <th style="background-color: grey; color:white;width: 25%;text-align: right;"> {{moneyFormat(model.precio_total ?? 0)}} €</th>
                </tr>
            </table>
        </div>
     


